import { render, staticRenderFns } from "./CheckAddressModal.vue?vue&type=template&id=bcda1a92&scoped=true&"
import script from "./CheckAddressModal.vue?vue&type=script&lang=js&"
export * from "./CheckAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcda1a92",
  null
  
)

export default component.exports